// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"zM","imageWrapper":"zN","image":"zO","copyrightAndBrandLogo":"zP","brandLogo":"zQ","copyright":"zR","rentalBadge":"zS"};